module.exports = __webpack_public_path__ + "img/reply-bg-mobile.735624e0.png";